export const inchesToMeters = inches => inches / 39.370;
